import { useQuery } from '@tanstack/react-query';
import type { NavigationNode } from '@opus/types';
import { api } from './authStore';
import { queryKeys, STALE } from './queryKeys';

/** The preserved menu — the compile-time fallback if the api is down (brief 003-000-001 §1). */
export const NAV_FALLBACK: NavigationNode[] = [
  { id: 'home', label: 'Home', type: 'internal', path: '/', target: '_self', children: [] },
  { id: 'art', label: 'Art', type: 'internal', path: '/art', target: '_self', children: [] },
  { id: 'code', label: 'Code', type: 'internal', path: '/code', target: '_self', children: [] },
  { id: 'music', label: 'Music', type: 'internal', path: '/music', target: '_self', children: [] },
  { id: 'blog', label: 'Blog', type: 'internal', path: '/blog', target: '_self', children: [] },
  { id: 'services', label: 'Services', type: 'internal', path: '/services', target: '_self', children: [] },
  { id: 'about', label: 'About', type: 'internal', path: '/about', target: '_self', children: [] },
  { id: 'contact', label: 'Contact', type: 'internal', path: '/contact', target: '_self', children: [] },
  { id: 'interactive', label: 'Interactive', type: 'internal', path: '/interactive', target: '_self', children: [] },
];

export function useNavigation(identifier = 'main') {
  return useQuery({
    queryKey: queryKeys.navigation(identifier),
    queryFn: async (): Promise<NavigationNode[]> => {
      const res = await api.get<{ data: NavigationNode[] }>(`/public/navigation/${identifier}`);
      return res.data.data;
    },
    staleTime: STALE.navigation,
    retry: false,
    // first paint uses the fallback while the api answers
    placeholderData: NAV_FALLBACK,
  });
}
